//Reset data
export const RESET = "AGENT_UPDATE_RESET"

export const SET_IS_UPDATED = "AGENT_UPDATE_SET_IS_CREATE"
export const SET_NOT_UPDATED = "AGENT_UPDATE_SET_NOT_CREATE"
//Loading
export const SET_TOGGLE_LOADING = "AGENT_UPDATE_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "AGENT_UPDATE_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "AGENT_UPDATE_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "AGENT_UPDATE_SET_MESSAGE"
export const SET_IS_SUCCESS = "AGENT_UPDATE_SET_IS_SUCCESS"
export const SET_IS_ERROR = "AGENT_UPDATE_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "AGENT_UPDATE_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "AGENT_UPDATE_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "AGENT_UPDATE_SET_HIDE_MESSAGE"

//Data
export const SET_UPDATE = "AGENT_UPDATE_SET_UPDATE"
export const SET_CURRENT_ITEM = "AGENT_UPDATE_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "AGENT_UPDATE_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "AGENT_UPDATE_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "AGENT_UPDATE_SET_HIDE_MODAL"


export const SET_MODAL = "AGENT_UPDATE_SET_MODAL"
export const SET_MODAL_CONTENT = "AGENT_UPDATE_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "AGENT_UPDATE_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "AGENT_UPDATE_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "AGENT_UPDATE_SET_MODAL_TYPE"